import Photos from '../../../../components/Gallery';
import {
  AtividadesDeFormacao2024One,
  AtividadesDeFormacao2024Two,
  AtividadesDeFormacao2024Three,
  AtividadesDeFormacao2024Four,
  AtividadesDeFormacao2024Five,
  AtividadesDeFormacao2024Six,
  AtividadesDeFormacao2024Seven,
  AtividadesDeFormacao2024Eight,
  AtividadesDeFormacao2024Nine,
  AtividadesDeFormacao2024Ten,
  AtividadesDeFormacao2024Eleven,
  AtividadesDeFormacao2024Twelve,
  AtividadesDeFormacao2024Thirteen,
} from '../../../../assets';

function PhotosEdictRefinementSeminar() {
  const listPhotos = [
    {
      id: 0,
      type: '',
      name: '',
      photos: [
        {
          img: AtividadesDeFormacao2024One,
          type: '',
        },
        {
          img: AtividadesDeFormacao2024Two,
          type: '',
        },
        {
          img: AtividadesDeFormacao2024Three,
          type: '',
        },
        {
          img: AtividadesDeFormacao2024Four,
          type: '',
        },
        {
          img: AtividadesDeFormacao2024Five,
          type: '',
        },
        {
          img: AtividadesDeFormacao2024Six,
          type: '',
        },
        {
          img: AtividadesDeFormacao2024Seven,
          type: '',
        },
        {
          img: AtividadesDeFormacao2024Eight,
          type: '',
        },
        {
          img: AtividadesDeFormacao2024Nine,
          type: '',
        },
        {
          img: AtividadesDeFormacao2024Ten,
          type: '',
        },
        {
          img: AtividadesDeFormacao2024Eleven,
          type: '',
        },
        {
          img: AtividadesDeFormacao2024Twelve,
          type: '',
        },
        {
          img: AtividadesDeFormacao2024Thirteen,
          type: '',
        },
      ]
    }
  ];

  return (
    <Photos
      list={listPhotos}
    />
  );
}

export default PhotosEdictRefinementSeminar;
